import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader, Card } from '../components/ui';

const DashboardPage: React.FC = () => {
  const quickLinks = [
    { to: '/admin/hero', icon: '🏠', label: 'Hero Section', desc: 'Edit title and CTAs' },
    { to: '/admin/about', icon: '👤', label: 'About', desc: 'Update bio and stats' },
    { to: '/admin/music', icon: '🎵', label: 'Music', desc: 'Manage featured content' },
    { to: '/admin/announcement', icon: '📢', label: 'Announcement', desc: 'Toggle popup modal' },
    { to: '/admin/albums', icon: '💿', label: 'Albums', desc: 'Manage discography' },
    { to: '/admin/beats', icon: '🎹', label: 'Beats', desc: 'Update beats gallery' },
  ];

  return (
    <>
      <PageHeader
        title="Dashboard"
        subtitle="Welcome to your CMS. Manage all your portfolio content from here."
      />

      <div className="admin-content">
        <div className="admin-stats-grid">
          <div className="admin-stat-card">
            <div className="admin-stat-icon">📝</div>
            <div className="admin-stat-value">7</div>
            <div className="admin-stat-label">Content Sections</div>
          </div>
          <div className="admin-stat-card">
            <div className="admin-stat-icon">💿</div>
            <div className="admin-stat-value">3</div>
            <div className="admin-stat-label">Albums</div>
          </div>
          <div className="admin-stat-card">
            <div className="admin-stat-icon">🎹</div>
            <div className="admin-stat-value">8</div>
            <div className="admin-stat-label">Beats</div>
          </div>
          <div className="admin-stat-card">
            <div className="admin-stat-icon">🤝</div>
            <div className="admin-stat-value">4</div>
            <div className="admin-stat-label">Collaborators</div>
          </div>
        </div>

        <Card title="Quick Actions" subtitle="Jump to frequently used sections">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: 16
          }}>
            {quickLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: 16,
                  background: 'var(--admin-bg)',
                  border: '1px solid var(--admin-border)',
                  borderRadius: 8,
                  textDecoration: 'none',
                  color: 'inherit',
                  transition: 'all 0.15s ease',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = 'var(--admin-surface-hover)';
                  e.currentTarget.style.borderColor = 'var(--admin-border-hover)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = 'var(--admin-bg)';
                  e.currentTarget.style.borderColor = 'var(--admin-border)';
                }}
              >
                <span style={{ fontSize: '1.5rem' }}>{link.icon}</span>
                <div>
                  <div style={{ fontWeight: 500 }}>{link.label}</div>
                  <div style={{ fontSize: '0.8rem', color: 'var(--admin-text-muted)' }}>
                    {link.desc}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </Card>

        <div style={{ marginTop: 24 }}>
          <Card title="Getting Started" subtitle="Tips for using the CMS">
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: 12
            }}>
              <li style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                <span style={{ color: 'var(--admin-primary)' }}>1.</span>
                <div>
                  <strong>Bilingual Content</strong>
                  <p style={{ color: 'var(--admin-text-muted)', fontSize: '0.9rem', marginTop: 4 }}>
                    Most sections have EN/RO tabs. Fill in both for full language support.
                  </p>
                </div>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                <span style={{ color: 'var(--admin-primary)' }}>2.</span>
                <div>
                  <strong>Auto-Save</strong>
                  <p style={{ color: 'var(--admin-text-muted)', fontSize: '0.9rem', marginTop: 4 }}>
                    Changes are saved when you click "Save Changes". Look for the success notification.
                  </p>
                </div>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                <span style={{ color: 'var(--admin-primary)' }}>3.</span>
                <div>
                  <strong>Media Uploads</strong>
                  <p style={{ color: 'var(--admin-text-muted)', fontSize: '0.9rem', marginTop: 4 }}>
                    Upload images (max 5MB) and audio files (max 20MB) directly from forms.
                  </p>
                </div>
              </li>
            </ul>
          </Card>
        </div>
      </div>
    </>
  );
};

export default DashboardPage;
